import { useHotkeys } from "@permutation-city/ui";
import { useNavigate } from "@tanstack/react-router";

export function IncentivesFormNavButton() {
  const navigate = useNavigate();

  useHotkeys("ctrl + C", () => {
    navigate({
      to: "/create",
    });
  });

  return null;

  // TODO: add back, only show to owner
  // return (
  //   <ActionButton
  //     hotkey="^+C"
  //     onClick={() => {
  //       navigate({
  //         to: "/create",
  //       });
  //     }}
  //   >
  //     Set incentive
  //   </ActionButton>
  // );
}
